const Footer = () => {
  return (
    <footer className="bg-white h-full text-cyan-800 flex align-middle justify-center">
      <p className="p-8 text-lg opacity-75">
        Created by{" "}
        <a
          href="https://robertmcabee.com"
          className="underline decoration-cyan-500 decoration-2 underline-offset-2 hover:text-cyan-500 transition duration-200 ease-in-out"
        >
          Robert McAbee
        </a>
      </p>
    </footer>
  );
};

export default Footer;
